<template>
  <ul>
    <li>Format : {{panneau.format}}</li>
    <li>Materiel : {{panneau.materiel}}</li>
    <li>Eclairée : {{panneau.eclaire}}</li>
    <li>Azimut : {{panneau.azimut}}</li>
    <li>En venant de : {{panneau.enVenantDe}}</li>
    <li>En allant vers : {{panneau.enAllantVers}}</li>
    <li>Nombre de propositions : {{panneau.nbPropositions}}</li>
  </ul>
</template>

<script>
export default {
  name: 'caracteristiques',
  props: ['panneau'],
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/recherche/cartographie/caracteristiques.vue